import { createRouter } from '../routing';

export const appRouter = createRouter({
  'user': '/',
  'list': '/:listId/:token?'
});
